<!--
 * @Author: mazhigang
 * @Date: 2023-04-23 10:45:21
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-09-25 19:51:29
-->
<template>
  <div id="app" ref="container">
    <router-view />
  </div>
</template>

<script>
// import Watermark from "./utils/watermark";
export default {
  components: {},
  name: "App",
  data() {
    return {};
  },
  created: function() {
    // Watermark.set("水印内容", this.$refs.container);
  },
  watch: {}
};
</script>

<style>
#app {
  color: #000;
  margin: 0;
  padding: 0;
  border: 0;
  position: relative;
  overflow: hidden;
  font-family: PingFangSC-Regular, PingFang SC;
}
body {
  margin: 0;
  padding: 0;
  border: 0;
  background: #fcfaf9;
  font-family: PingFangSC-Regular, PingFang SC;
}
.yinyin {
  width: 51px;
  height: 45px;
  background: rgba(120, 182, 255, 0.8);
  border-radius: 0px 0px 0px 0px;
  filter: blur(20px);
  position: absolute;
  top: 0px;
  left: 38%;
  z-index: -1;
}
.yinyin2 {
  width: 51px;
  height: 45px;
  background: rgba(120, 255, 223, 0.5);
  border-radius: 0px 0px 0px 0px;
  filter: blur(20px);
  position: absolute;
  top: 0px;
  right: 38%;
  z-index: -1;
}
</style>



// WEBPACK FOOTER //
// src/App.vue